import { urgencyOf } from "./urgency.js";
export const EMPTY_TASK_FILTERS = {
    query: "",
    clientId: "all",
    userId: "all",
    stage: "all",
    priority: "all",
    due: "all",
};
/** True when a sticky belongs in the current board view. */
export function matchesTaskFilters(task, filters, viewerId, now = new Date()) {
    if (filters.clientId !== "all" && task.client_id !== filters.clientId)
        return false;
    if (filters.userId === "me" && task.assignee_id !== viewerId)
        return false;
    if (filters.userId === "unassigned" && task.assignee_id !== null)
        return false;
    if (filters.userId !== "all" &&
        filters.userId !== "me" &&
        filters.userId !== "unassigned" &&
        task.assignee_id !== filters.userId)
        return false;
    if (filters.stage !== "all" && task.stage !== filters.stage)
        return false;
    if (filters.priority !== "all" && task.priority !== filters.priority)
        return false;
    const urgency = urgencyOf(task, now);
    if (filters.due === "overdue" && urgency !== "overdue")
        return false;
    if (filters.due === "due_soon" && urgency !== "due_soon")
        return false;
    if (filters.due === "upcoming" &&
        (!task.due_date || task.stage === "completed" || urgency !== "normal"))
        return false;
    if (filters.due === "no_date" && task.due_date !== null)
        return false;
    const query = filters.query.trim().toLocaleLowerCase();
    if (query && !task.title.toLocaleLowerCase().includes(query))
        return false;
    return true;
}
export function taskFilterCount(filters) {
    return (Number(Boolean(filters.query.trim())) +
        Number(filters.clientId !== "all") +
        Number(filters.userId !== "all") +
        Number(filters.stage !== "all") +
        Number(filters.priority !== "all") +
        Number(filters.due !== "all"));
}
//# sourceMappingURL=filters.js.map